<template>
    <div>
        <!-- Start the code for this screen here -->
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <nav class="navbar navbar-expand-lg bg-info text-white">
                    <span><b>Forgot Password</b></span>
                </nav>
                <center>
                    <span :style="msgcolor"><b>{{information}}</b></span>
                </center>
                <br />
                <center>
                    <span>
                        Luxury Lease Partners LLC<br />
                        210 Summit Ave. Suite C4<br />
                        Montvale, N.J. 07645 &nbsp; &nbsp;Contact : (201) 822-4870
                    </span>
                </center>
                <br />
                <br />

                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col d-flex justify-content-end align-items-center">
                        <label class="col-form-label col-form-label-sm">E-Mail</label>
                    </div>
                    <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input type="text" v-validate="'required'" class="form-control input-sm" name="EmailId" v-model.trim="emailId" data-vv-as="EmailId" placeholder="example@domain.com" />
                        <div v-if="errors.has('EmailId')" class="alert-danger">{{ errors.first('EmailId') }}</div>
                    </div><!--col-end-->
                </div><!--row end-->

                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                    <div class="col-lg-4 col-md-4 col-sm-4 d-flex justify-content-end align-items-center">
                        <button class="btn btn-secondary" @click="forgotpassword()">Submit</button> &nbsp;&nbsp;&nbsp;
                        <router-link to="/login" class="btn btn-secondary" tag="a"> Back</router-link>
                    </div><!--col end-->
                </div><!--row end-->
            </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
    </div>
</template>
<script>
import httpcommonzero from '../js/http-common-zero.js'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpemployee from '../js/http-employee.js'
export default {
  components: { MainMenu, BottomFooter },
  data () {
    return {
      emailId: '',
      information: '',
      emailList: [],
      msgcolor: {
        color: 'black'
      }
    }
  },

  methods: {
    fetchdata: function () {},

    forgotpassword () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          httpemployee
            .post('/userlogin/forgot/' + this.emailId)
            .then((response) => {
              var status = response.data
              if (status == 'Mail Sent Success!') {
                this.information = 'Mail Sent Success!'
                this.msgcolor.color = 'Blue'
              }
              if (status == 'Account doesnt exist') {
                this.information = 'Account doesnt exist'
                this.msgcolor.color = 'Red'
              }
              console.log(status)
              this.emailId = ''
            })
            .catch((e) => {
              this.information = 'Could not connect to the sytem!!'
              this.emailId = ''
              this.msgcolor.color = 'Red'
              this.errors.push(e)
            })
        }
      })
    }
  },

  mounted: function () {
    this.fetchdata()
  }
}
</script>
<style scoped></style>
